export default __webpack_public_path__ + "static/media/Tunic of Bedlam.0b5c8d04.jpg";